export const collaborationSetup = {
  junior: {
    workflows: [
      { name: 'Content Review Process', description: 'Collaborate with design and product teams for content review', frequency: 'Weekly content review sessions' },
      { name: 'UX Writing Integration', description: 'Work with designers to integrate content into user interfaces', process: 'Design handoff and content implementation' },
      { name: 'Content Documentation', description: 'Document content decisions and maintain style guides', deliverable: 'Content guidelines and documentation' }
    ],
    tools: [
      { name: 'Slack', purpose: 'Content team communication and feedback', channels: ['#content-design', '#design-team', '#product-team'] },
      { name: 'Figma', purpose: 'Content integration in design files', access: 'Editor permissions for content layers' },
      { name: 'Notion', purpose: 'Content documentation and style guides', permissions: 'Editor access to content spaces' }
    ],
    processes: [
      { name: 'Content Request Process', steps: ['Receive content request', 'Understand context and goals', 'Draft content', 'Review with stakeholders', 'Implement feedback'] },
      { name: 'Content Quality Assurance', steps: ['Review content for clarity', 'Check brand voice alignment', 'Validate against style guide', 'Test with users'] }
    ]
  },
  mid: {
    workflows: [
      { name: 'Content Strategy Development', description: 'Lead content strategy initiatives across product areas', responsibility: 'Cross-functional content planning' },
      { name: 'Content System Management', description: 'Maintain and evolve content design systems', scope: 'Organization-wide content consistency' },
      { name: 'Content Performance Analysis', description: 'Analyze content effectiveness and user engagement', commitment: 'Data-driven content optimization' }
    ],
    tools: [
      { name: 'ContentKing', purpose: 'Content optimization and performance tracking', access: 'Admin permissions for content analysis' },
      { name: 'Miro', purpose: 'Content strategy planning and user journey mapping', permissions: 'Board creation and facilitation' },
      { name: 'Airtable', purpose: 'Content inventory and workflow management', access: 'Database creation and management' }
    ],
    processes: [
      { name: 'Content Audit Process', steps: ['Inventory existing content', 'Analyze performance metrics', 'Identify gaps and opportunities', 'Create improvement roadmap'] },
      { name: 'Cross-team Content Alignment', steps: ['Facilitate content planning sessions', 'Align on content priorities', 'Coordinate content delivery', 'Monitor content consistency'] }
    ]
  },
  senior: {
    workflows: [
      { name: 'Content Leadership', description: 'Lead content strategy and team development across organization', responsibility: 'Content program leadership and vision' },
      { name: 'Content Operations at Scale', description: 'Build and optimize content operations for enterprise scale', scope: 'Organization-wide content efficiency' },
      { name: 'Content Innovation', description: 'Drive innovation in content creation and delivery methods', impact: 'Content practice advancement' }
    ],
    tools: [
      { name: 'Enterprise CMS Platform', purpose: 'Large-scale content management and governance', role: 'Platform strategist and administrator' },
      { name: 'AI Content Tools', purpose: 'AI-assisted content creation and optimization', access: 'Full platform access and strategy development' },
      { name: 'Content Analytics Suite', purpose: 'Advanced content performance analysis and insights', role: 'Analytics strategy and implementation lead' }
    ],
    processes: [
      { name: 'Content Program Strategy', steps: ['Define content vision and goals', 'Build content capabilities', 'Measure content impact', 'Scale content practices'] },
      { name: 'Content Culture Development', steps: ['Evangelize content best practices', 'Train teams on content strategy', 'Build content-conscious culture', 'Measure cultural adoption'] }
    ]
  }
};
